import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import MapModal from "components/maps/MapModal";
import AzureMapModal from "components/maps/azure/AzureMapModal";

const MapManagerModal = ({ provider, ...props }) => {
    const { panel, azureMapsKey } = useContext(AuthContext);
    const selectedProvider = provider || panel?.map_type || 'lf';

    const renderModalByProvider = () => {
        switch (selectedProvider) {
            case 'az':
                return <AzureMapModal azureMapsKey={azureMapsKey} {...props} />;
            case 'lf':
            default:
                return <MapModal {...props} />;
        }
    };

    return renderModalByProvider();
};

export default MapManagerModal;
